// @flow strict

import type {
  AttractionDatesClearRecord,
  AttractionRangeDatesClearRecord,
  AttractionDatesInfoRecord,
  AttractionDatesDefaultRecord,
  AttractionRangeDatesInfoRecord,
  AttractionRangeDatesDefaultRecord,
  AttractionPaxRecord,
} from './records';

class AttractionsAccumulator {
  today: Date = new Date();
  clearedDate: boolean = false;
  userSetRangeDates: boolean = false;

  fromDate: null | Date = null;
  toDate: null | Date = null;
  singleDate: null | Date = null;
  adults: number = 0;
  children: number = 0;

  // eslint-disable-next-line no-unused-vars
  AC(_: AttractionDatesClearRecord) {
    this.fromDate = null;
    this.toDate = null;
    this.singleDate = null;
    this.clearedDate = true;
  }
  // eslint-disable-next-line no-unused-vars
  ARC(_: AttractionRangeDatesClearRecord) {
    this.fromDate = null;
    this.toDate = null;
    this.singleDate = null;
    this.clearedDate = true;
  }
  AD(record: AttractionDatesInfoRecord) {
    this.validateAndRecordSingleDate(record.tourDate);
  }
  ADD(record: AttractionDatesDefaultRecord) {
    if (this.singleDate === null && !this.clearedDate) {
      this.validateAndRecordSingleDate(record.tourDate);
    }
  }
  ARD(record: AttractionRangeDatesInfoRecord) {
    this.validateAndRecordRangeDates(record.fromDate, record.toDate);
  }
  ARDD(record: AttractionRangeDatesDefaultRecord) {
    if (this.fromDate === null && this.toDate === null && !this.clearedDate) {
      this.validateAndRecordRangeDates(record.fromDate, record.toDate);
    }
  }
  APAX(record: AttractionPaxRecord) {
    this.adults = record.adults;
    this.children = record.children;
  }

  validateAndRecordSingleDate(date: null | Date) {
    if (date === null || date < this.today) {
      return;
    }
    this.singleDate = date;
    if (
      this.fromDate === null ||
      this.toDate === null ||
      this.singleDate < this.fromDate ||
      this.singleDate > this.toDate
    ) {
      this.fromDate = date;
      this.toDate = date;
    }
  }
  validateAndRecordRangeDates(fromDate: null | Date, toDate: null | Date) {
    if (fromDate == null || fromDate < this.today || toDate == null || toDate < fromDate) {
      return;
    }
    this.fromDate = fromDate;
    this.toDate = toDate;
    if (this.singleDate == null || this.singleDate < fromDate || this.singleDate > toDate) {
      this.singleDate = fromDate;
    }
    this.userSetRangeDates = true;
  }
}

export default AttractionsAccumulator;
